/**
 * Typed hooks wrapping the training contract's `today` feed — the clock-out gate and the overrun
 * banner read it. (My learning has its own query, `features/learning/hooks.ts`.)
 */

import { tsr } from '../../lib/api.js';

const TRAINING_KEY = 'training';

export const trainingKeys = {
  today: () => [TRAINING_KEY, 'today'] as const,
};

export function useTrainingToday() {
  return tsr.trainingMe.today.useQuery({
    queryKey: trainingKeys.today(),
    // Polled: the overrun banner and the clock-out gate summary need to reflect a deadline that
    // just passed without the employee having to reload the page.
    refetchInterval: 60_000,
  });
}
